import Vue from 'vue';
import {
  createTemp, getTemplatesAdmin, getTemplates, deleteTemp, updateTemp
} from '../../../services/backendService/templatesService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  temps: [],
  pagination: {
    current_page: 0,
    per_page: 5
  }
};

 // actions
const actions = {
  // 新增模板
  async createTempHandler({}, data) {
    await createTemp(data);
  },
  //* *** 後台模板 ****//
  // 取得後台模板
  async getTemplatesAdminHandler({ commit }, formData) {
    const data = await getTemplatesAdmin(formData);
    commit('setTemps', data);
  },
  //* *** 前台BA模板 ****//
  // 取得前台BA模板
  async getTemplatesHandler({ commit }, formData) {
    const data = await getTemplates(formData);
    commit('setTemps', data);
  },
  // 刪除前台模板
  async deleteTempHandler({}, id) {
    await deleteTemp(id);
  },
  // 更新前台模板
  async updateTempHandler({}, updateInfo) {
    await updateTemp(updateInfo);
  }
};

// mutations
const mutations = {
  setTemps(state, data) {
    Vue.set(state, 'temps', state.temps.concat(data.data.templates));
    Vue.set(state, 'pagination', data.pagination);
  },
  // 重置分頁
  resetInfiniteLoadingData(state) {
    Vue.set(state, 'temps', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  }
};

 export default {
   namespaced: true,
   state,
   actions,
   mutations
 };
